import * as React from 'react'

import { useConversation } from './ConversationProvider'
import {
  useCatalogItemCart,
  type UseCatalogItemCartResult,
} from '../hooks/useCatalogItemCart'

export type CatalogItemCartContextValue = UseCatalogItemCartResult

export const CatalogItemCartContext =
  React.createContext<Nullable<CatalogItemCartContextValue>>(null)

export const CatalogItemCartProvider = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  const { sendMessage } = useConversation()
  const cart = useCatalogItemCart(sendMessage)

  return (
    <CatalogItemCartContext.Provider value={cart}>
      {children}
    </CatalogItemCartContext.Provider>
  )
}

export const useCatalogItemCartContext = (): CatalogItemCartContextValue => {
  const context = React.useContext(CatalogItemCartContext)
  if (!context) {
    throw new Error(
      'useCatalogItemCartContext must be used within a CatalogItemCartProvider'
    )
  }
  return context
}
